import { render, staticRenderFns } from "./LocationsSnippet.vue?vue&type=template&id=232894c8&"
import script from "./LocationsSnippet.vue?vue&type=script&lang=js&"
export * from "./LocationsSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports